// extracted by mini-css-extract-plugin
module.exports = {"header":"landings-header__1x93U","buttons":"landings-buttons__2effE"};